import React, { Component } from 'react';
import autoBind from 'react-autobind/src/autoBind';
import { withTranslation } from 'react-i18next';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { Entities, formatMoney } from 'src/common';
import TableHelper from 'src/utils/table-helper';
import CircularProgress from 'material-ui/CircularProgress';
import ErrorMessage from 'src/components/misc/error-message';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import DatePicker from 'material-ui/DatePicker';
import moment from 'moment';

class AdminBookingFeedbackAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.tableHelper = new TableHelper();
        this.state = {
            startedFetching: false,
            fromDate: moment().startOf('month').toDate(),
            toDate: moment().toDate(),
            excludeSaleIntegrations: true,
        };
    }

    getQueryParams() {
        const queryParams = [];
        if (this.state.fromDate && this.state.toDate) {
            queryParams.push(`fromDate=${moment(this.state.fromDate).format('YYYY-MM-DD')}`);
            queryParams.push(`toDate=${moment(this.state.toDate).format('YYYY-MM-DD')}`);
        }

        return queryParams.join('&');
    }

    componentWillMount() {
        this.props.fetchAllCustomRepository(Entities.BOOKING_FEEDBACK, 'get-all', this.getQueryParams());
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.tableHelper.processPaginationAfterUpdate(
                prevProps.bookingFeedback,
                this.props.bookingFeedback,
                this.table,
            )
        )
            this.setState({ renderSelection: !this.state.renderSelection });

        if (prevState.fromDate !== this.state.fromDate || prevState.toDate !== this.state.toDate) {
            this.props.fetchAllCustomRepository(Entities.BOOKING_FEEDBACK, 'get-all', this.getQueryParams());
        }
    }

    componentWillReceiveProps(nextProps) {
        const { bookingFeedback } = nextProps;

        if (bookingFeedback.isFetching && !this.state.startedFetching) this.setState({ startedFetching: true });

        this.tableHelper.processPagination(bookingFeedback.items.length);
    }

    createCustomToolBar(props) {
        const { t } = this.props;
        const { isFetching } = this.props.bookingFeedback;

        return (
            <>
                <div className="col-md-12">
                    <div className="col-md-12">
                        <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                            <div>
                                <DatePicker
                                    value={this.state.fromDate}
                                    container="inline"
                                    disabled={isFetching || this.state.noDate}
                                    formatDate={date => moment(date).format('DD.MM.YYYY')}
                                    floatingLabelText={t('search_requests.from.title')}
                                    onChange={(_event, value) => this.setState({ fromDate: value })}
                                    maxDate={this.state.toDate}
                                    autoOk={true}
                                    textFieldStyle={{ width: 130, marginLeft: 7 }}
                                />
                            </div>
                            <div>
                                <DatePicker
                                    value={this.state.toDate}
                                    container="inline"
                                    disabled={isFetching || this.state.noDate}
                                    formatDate={date => moment(date).format('DD.MM.YYYY')}
                                    floatingLabelText={t('search_requests.to.title')}
                                    onChange={(_event, value) => this.setState({ toDate: value })}
                                    minDate={this.state.fromDate}
                                    autoOk={true}
                                    textFieldStyle={{ width: 130, marginLeft: 30 }}
                                />
                            </div>

                            <div
                                style={{
                                    width: 400,
                                    marginRight: 6,
                                    marginTop: 34,
                                    marginLeft: 'auto',
                                }}>
                                {props.components.searchPanel}
                            </div>
                        </div>
                        <div style={{ marginRight: 'auto' }}>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => {
                                    if (this.table) {
                                        this.table.handleExportCSV();
                                    }
                                }}>
                                {t('common_phrases.export_list')}
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    render() {
        const { bookingFeedback, t } = this.props;

        const finishFetching = this.state.startedFetching && !bookingFeedback.isFetching;
        const tableData = [];
        //

        if (finishFetching && bookingFeedback.items.length > 0) {
            bookingFeedback.items.map(feedback => {
                tableData.push({
                    id: feedback.id,
                    createdAt: new Date(feedback.createdAt).toLocaleDateString('de-DE'),
                    bookingIdentifier: feedback.booking.identifier,
                    email: feedback.booking.customerContactData.email,
                    price: formatMoney(feedback.booking.priceSummary.total[0]),
                    feedback: feedback.feedback,
                    customerNote: feedback.customerNote,
                });
            });
        }
        return (
            <div>
                <legend className="legend">{t('booking_feedback.booking_feedback')}</legend>

                {(() => {
                    if (!finishFetching) return <CircularProgress />;
                    else if (bookingFeedback.error) return <ErrorMessage object={bookingFeedback} />;
                    else
                        return (
                            <BootstrapTableErrorBoundary>
                                <BootstrapTable
                                    ref={ref => (this.table = ref)}
                                    data={tableData}
                                    exportCSV={true}
                                    striped={true}
                                    hover={true}
                                    condensed={true}
                                    pagination={true}
                                    options={Object.assign(
                                        { toolBar: this.createCustomToolBar },
                                        this.tableHelper.getOptions(finishFetching),
                                    )}
                                    selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                                    searchPlaceholder={t('common_phrases.search')}
                                    search={true}>
                                    <TableHeaderColumn
                                        columnTitle={true}
                                        dataField="id"
                                        width="50"
                                        isKey={true}
                                        export={true}>
                                        {' '}
                                        {t('common_phrases.id')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        export={true}
                                        columnTitle={true}
                                        dataField="createdAt"
                                        dataSort={true}
                                        width="120">
                                        {t('referrals.createdAt')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        export={true}
                                        columnTitle={true}
                                        dataField="bookingIdentifier"
                                        dataSort={true}
                                        width="100">
                                        {t('common_phrases.booking_id')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        export={true}
                                        columnTitle={true}
                                        dataField="price"
                                        dataSort={true}
                                        width="120">
                                        {t('booked_tasks.price')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        export={true}
                                        columnTitle={true}
                                        dataField="feedback"
                                        dataSort={true}
                                        width="100">
                                        {t('booking_feedback.rating')}
                                    </TableHeaderColumn>
                                    <TableHeaderColumn
                                        export={true}
                                        columnTitle={true}
                                        dataField="customerNote"
                                        dataSort={true}>
                                        {t('booking_feedback.customer_comment')}
                                    </TableHeaderColumn>
                                </BootstrapTable>
                            </BootstrapTableErrorBoundary>
                        );
                })()}
            </div>
        );
    }
}

export default withTranslation()(composeModalActions(AdminBookingFeedbackAdministration));
